module.exports = __webpack_public_path__ + "img/new-logo.80273948.jpg";